import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Modal from "react-bootstrap/Modal";
import { getSkillByDeptID } from "../HR/Skills/subSkills/api/calls";
import TableLoader from "../../CommanCom/TableLoader";
import Select from "react-select";
import * as XLSX from "xlsx";

function EmployeeListCom() {
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem("key"));

  const get_oermission_data = useSelector((state) => state);
  const extract_permissions = get_oermission_data.login_Permission.permissions
    ? JSON.parse(get_oermission_data.login_Permission.permissions)
    : "";
  const hr_permission = get_oermission_data.login_Permission.permissions;

  const user_info = get_oermission_data.login_Permission.user_data;
  // console.log('get_oermission_data');
  // console.log(user_info.deptId);
  // console.log(user_info.id);
  // console.log('get_oermission_data');

  const hr_permission_arr = Array();
  if (hr_permission) {
    const hr_permission_arr1 = JSON.parse(hr_permission).split(",");
    hr_permission_arr1.map((item, ind) => {
      hr_permission_arr.push(item);
    });
  }
  const fileRef = useRef(null);
  const pagination = useRef();
  const [searchemail, setSearchemail] = useState("");
  const [emplist, setEmplist] = useState([]);
  const [perPage, setPerpage] = useState("");
  const [totalitem, setTotalitem] = useState("");
  const [searchbytext, setSearchbytext] = useState("");
  const [dept, setDept] = useState([]);
  const [deptid, setDeptid] = useState("");
  const [skill, setSkill] = useState("");
  const [activeType, setActiveType] = useState(1);
  const [skillsList, setSkillsList] = useState([]);
  const [page_Number, setPage_Number] = useState(1);
  const [loadPage, setLoadPage] = useState(true);
  const [comdata, setComdata] = useState([]);
  const [showModalctc, setShowModalctc] = useState(false);
  const [selectedSkill, setSelectedSkill] = useState("");
  const [selectedEmpId, setSelectedEmpId] = useState(null);

  const [role, setRole] = useState("");

  const setPage = ({ selected }) => {
    setLoadPage(true);
    getuserlist(
      compId,
      searchbytext,
      selected + 1,
      deptid,
      skill,
      activeType,
      role,
    );
  };
  useEffect(() => {
    setLoadPage(true);
    getuserlist(
      compId,
      searchbytext,
      page_Number,
      deptid,
      skill,
      activeType,
      role,
    );
    getDepartment();
    getCompanyList();
    //get_skills_list()
  }, []);
  const [empCode, setempCode] = useState([]);
  const [empId, setempId] = useState([]);
  const [empCodeModal, setempCodeModal] = useState(false);
  const [err, setErr] = useState("");
  const [msg, setSmg] = useState("");
  const [btnstatus, setBtnstatus] = useState(true);
  const handleEmployeeCode = (empCode, id) => {
    setempCode(empCode);
    setempId(id);
    setempCodeModal(true);
  };
  const handleShowModal = () => {
    setempCodeModal(true);
  };
  const [empcode, setEmpcode] = useState("");
  const [empCodeError, setEmpCodeError] = useState("");

  const checkEmployeeCode = async (code) => {
    if (!code.trim()) {
      setEmpCodeError("");
      return;
    }

    try {
      const response = await fetch(SERVER_URL + `api/employee/check-empcode`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
        body: JSON.stringify({
          empcode: code,
          employeeId: empId, // Current employee ID in edit mode
        }),
      });

      const data = await response.json();

      if (data.status == true) {
        setEmpCodeError("Employee Code already exists");
        setBtnstatus(true);
      } else {
        setEmpCodeError("");
        setBtnstatus(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSave = async () => {
    try {
      const response = await fetch(
        `${SERVER_URL}api/employee/updateEmployeeCode`,
        {
          method: "POST", // or PUT based on your API
          headers: {
            "Content-Type": "application/json",
            authorization: `bearer ${token.value}`,
          },
          body: JSON.stringify({
            employeeId: empId,
            empCode: empCode,
          }),
        },
      );

      const data = await response.json();
      console.log(data, "after update==================");
      if (data.status) {
        alert("Employee updated successfully");
        await getuserlist(
          compId,
          searchbytext,
          page_Number,
          deptid,
          skill,
          activeType,
          role,
        );

        setempCodeModal(false); // close modal if applicable

        // navigate("/employeelist");
      } else {
        alert(data.message || "Update failed");
      }
    } catch (error) {
      console.error("Update Error:", error);
      alert("Something went wrong");
    }
  };
  const getCompanyList = () => {
    const response = fetch(SERVER_URL + `api/common/company_list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        // setComdata(data.result);

        const options = data?.result?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setComdata(options);
      });
  };

  const getDepartment = async () => {
    const response = await fetch(SERVER_URL + `api/common/department_list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const options = data?.result?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setDept(options);
      });
  };

  const getuserlist = async (
    compId,
    textsearch,
    pagenumber,
    dept_id,
    skill,
    activeType,
    role,
  ) => {
    setLoadPage(true);
    const response = await fetch(
      SERVER_URL +
        `api/employee?query=${textsearch}&page=${
          pagenumber == "undefined" ? 1 : pagenumber
        }&department=${dept_id}&skill=${skill}&status=${activeType}&compId=${compId}&role=${role}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        setEmplist(data.users);
        setTotalitem(data.Emptotal[0].Total);
        setPerpage(data.limit);
        setLoadPage(false);
        setActiveType(activeType);
      });
  };

  const Search_filter = () => {
    getuserlist(
      compId,
      searchbytext,
      page_Number,
      deptid,
      skill,
      activeType,
      role,
    );
  };
  const Reset_filter = () => {
    setCompId("");
    setSkillsList([]);
    setSearchbytext("");
    setPage_Number(1);
    setDeptid("");
    setSkill("");
    setActiveType(1);

    setSelectedSkill("");
    setRole("");
    getuserlist("", "", 1, "", "", 1, "");
  };

  useEffect(() => {
    if (!deptid) {
      setSkillsList([]);
      setSkill("");
      setSelectedSkill("");
      setRole("");
      return;
    }
    getSkillByDeptID(deptid).then((res) => {
      if (res.status) {
        const options = res?.data?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setSkillsList(options);
      }
    });
  }, [deptid]);

  const [userId, setUserId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [emailcheck, setEmailcheck] = useState(1);
  const [systemcheck, setSystemcheck] = useState(0);

  const itModal = (id) => {
    setShowModal(true);
    setUserId(id);
  };
  const handleClose = () => {
    setUserId("");
    setShowModal(false);
    setempCodeModal(false);
    setempCode("");
    setempId("");
  };
  const handleemail = (e) => {
    setEmailcheck(e.target.value);
  };
  const handlesystem = (e) => {
    setSystemcheck(e.target.value);
  };
  const SaveItRequest = () => {
    sendReqToIT(emailcheck, systemcheck);
  };
  const sendReqToIT = async (emailcheck, systemcheck) => {
    const response = await fetch(SERVER_URL + "api/employee/hrReqEmail", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        userId: userId,
        emailcheck: emailcheck,
        systemcheck: systemcheck,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log(data)
      });
  };
  const [compId, setCompId] = useState("");
  const HandleCompany = (e) => {
    setCompId(e.target.value);
  };

  function ucword(str = "") {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }
  // const [file, setFile] = useState(null);
  // const [bulkuploadmsg, setBulkuploadmsg] = useState("");

  // const handleSubmit = async () => {
  //   if (!file) {
  //     alert("Please select XLSX file");
  //     return;
  //   }

  //   if (!file.name.toLowerCase().endsWith(".xlsx")) {
  //     alert("Only .xlsx files are allowed");
  //     return;
  //   }

  //   try {
  //     const formData = new FormData();
  //     formData.append("file", file);
  //     const response = await fetch(SERVER_URL + "api/common/uploadctcbulk", {
  //       method: "POST",
  //       body: formData,
  //       headers: {
  //         authorization: `Bearer ${token.value}`,
  //       },
  //     });
  //     const result = await response.json();
  //     // console.log(result.result.updatedRecords)
  //     if (result.status == false) {
  //       alert(response.msg || "Upload failed");
  //       return;
  //     }
  //     if (result.status == true) {
  //       setBulkuploadmsg(
  //         "The bulk upload process has been completed successfully. " +
  //           result.result.updatedRecords +
  //           " records were updated",
  //       );
  //       if (fileRef.current) {
  //         fileRef.current.value = "";
  //       }
  //       setTimeout(() => {
  //         setFile("");
  //         setBulkuploadmsg("");
  //         setShowModalctc(false);
  //       }, 2000);
  //     }
  //   } catch (err) {
  //     alert("Upload failed");
  //   }
  // };
  const [file, setFile] = useState(null);
  const [bulkuploadmsg, setBulkuploadmsg] = useState("");
  const [uploading, setUploading] = useState(false);

  const handleSubmit = async () => {
    if (!file) {
      alert("Please select XLSX file");
      return;
    }

    if (!file.name.toLowerCase().endsWith(".xlsx")) {
      alert("Only .xlsx files are allowed");
      return;
    }

    // Prevent multiple clicks
    if (uploading) {
      return;
    }

    try {
      setUploading(true);
      setBulkuploadmsg("");

      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(SERVER_URL + "api/common/uploadctcbulk", {
        method: "POST",
        body: formData,
        headers: {
          authorization: `Bearer ${token.value}`,
        },
      });

      const result = await response.json();

      console.log("Bulk Upload Response:", result);

      // --------------------------------
      // API ERROR
      // --------------------------------
      if (!response.ok || result.status === false) {
        setBulkuploadmsg(result.error || result.msg || "Bulk upload failed");

        return;
      }

      // --------------------------------
      // SUCCESS
      // --------------------------------
      if (result.status === true) {
        const updatedRecords = result.result?.updatedRecords || 0;

        const skippedRecords = result.result?.skippedRecords || 0;

        const totalRecords = result.result?.totalRecords || 0;

        setBulkuploadmsg(
          `Bulk upload completed successfully. ` +
            `${updatedRecords} records were updated` +
            ` and ${skippedRecords} records were skipped ` +
            `out of ${totalRecords} records.`,
        );

        // Clear file input
        if (fileRef.current) {
          fileRef.current.value = "";
        }

        setTimeout(() => {
          setFile(null);
          setBulkuploadmsg("");
          setShowModalctc(false);
        }, 3000);
      }
    } catch (err) {
      console.error("Bulk upload error:", err);

      setBulkuploadmsg(
        err.message || "Unable to upload file. Please try again.",
      );
    } finally {
      // Hide loader after API response
      setUploading(false);
    }
  };

  const downloadxlsxfile = async () => {
    try {
      const response = await fetch(`${SERVER_URL}api/common/getemplist`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token.value}`,
        },
      });

      const result = await response.json(); // always parse

      if (!response.ok) {
        console.error("Backend error:", result);
        throw new Error(result.msg || "API failed");
      }

      console.log("Success:", result.result);

      const secretKey = "QbsConnect@CTC#2025!SecureKey@32Chars";
      const empList = result.result;

      downloadEmployeeXLSX(empList);
      // empList.forEach((row, index) => {
      //   // const decryptedCTC = decryptCTC(row.ctc, secretKey);
      //   // console.log(`Row ${index + 1}:`);
      //   // console.log("User Code:", row);
      //   console.log("user_code (decrypted):", row.user_code);
      //   console.log("CTC:", row.ctc);
      //   console.log("CTCD (decrypted):", row.ctcd);
      // });

      // return result.result;
    } catch (error) {
      console.error("API Error:", error.message);
    }
  };
  const downloadEmployeeXLSX = (empList) => {
    if (!empList || empList.length === 0) {
      alert("No data to download");
      return;
    }

    // Prepare rows
    const excelData = empList.map((row, index) => ({
      Emp_code: row.user_code,
      MHR: row.actual_mhr,
    }));

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Employee Actual MHR");

    // Download file
    XLSX.writeFile(workbook, "Employee_MHR_List.xlsx");
  };
  // function getRoles(dept_id){
  // alert(dept_id)
  // }
  const [skillrole, setSkillrole] = useState([]);
  useEffect(() => {
    // alert(selectedSkill)
    if (!selectedSkill) {
      setSkillrole([]);
      setRole("");
      return;
    }
    getSkills_list(selectedSkill);
  }, [selectedSkill]);

  const getSkills_list = (id) => {
    const response = fetch(SERVER_URL + `api/common/getSkillsList?id=${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          // setSkillList(data.data);
          const options = data?.data?.map((item) => ({
            value: item.id,
            label: item.name,
          }));

          setSkillrole(options);
        }
      });
  };
  return (
    <>
      <Modal show={empCodeModal} size="md" id="confirm_login">
        <div className="modal-body">
          <div className="decorative-shape shape-1"></div>
          <div className="decorative-shape shape-2"></div>
          <button
            type="button"
            className="float-end btn_close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="icon icon-cross fw-bold"></i>
          </button>
          <div
            className="dash_white_box_ttl text-center"
            id="exampleModalLabel"
          >
            Edit Employee Code
          </div>
          <div className="mb-2">
            <label className="col-form-label">
              Employee Code :{" "}
              {empCodeError && (
                <small className="text-danger">{empCodeError}</small>
              )}
            </label>
            {/* <input
              style={{ borderColor: empCode }}
              type="text"
              onChange={(e) => {
                const value = e.target.value;
                checkEmployeeCode(value);
              }}
              value={empCode}
              className="form-control"
            /> */}
            <input
              type="text"
              value={empCode}
              onChange={(e) => {
                const value = e.target.value;
                setempCode(value);
                checkEmployeeCode(value);
              }}
              style={{
                borderColor: empCodeError ? "red" : "#ced4da",
              }}
              className="form-control"
            />
          </div>

          <div className="modalfooter">
            <span className="mb10 d-block text-right" style={{ color: err }}>
              {msg}
            </span>
            <div className="row">
              <div className="col-md-6 pr07">
                <button
                  type="button"
                  onClick={handleSave}
                  className="btn_5 w-100"
                  disabled={btnstatus}
                >
                  Save
                </button>
              </div>
              <div className="col-md-6 pl07">
                <button
                  type="button"
                  onClick={handleClose}
                  className="btn_6 w-100"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {showModal ? (
        <Modal show={showModal} size="md" id="confirm_login">
          <div className="modal-body">
            <button
              type="button"
              onClick={handleClose}
              className="float-end btn_close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="icon icon-cross"></i>
            </button>
            <div
              className="dash_white_box_ttl text-center"
              id="requestforemail"
            >
              Request for Email
            </div>
            <form>
              <div className="mb-2">
                <div className="form-label">Create Mail</div>
                <div className="form-check d-inline-block hand">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="mailstatus"
                    id="active"
                    onChange={handleemail}
                    value="1"
                    checked={emailcheck == 1}
                  />
                  <label className="form-check-label" for="active">
                    Yes
                  </label>
                </div>
                <div className="form-check d-inline-block hand ml20">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="mailstatus"
                    id="inactive"
                    onChange={handleemail}
                    value="0"
                    checked={emailcheck == 0}
                  />
                  <label className="form-check-label" for="inactive">
                    No
                  </label>
                </div>
              </div>
              <div className="mb-2">
                <div className="form-label">System Require</div>
                <div className="form-check d-inline-block hand">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="systemstatus"
                    id="activesystem"
                    onChange={handlesystem}
                    value="1"
                    checked={systemcheck == 1}
                  />
                  <label className="form-check-label" for="activesystem">
                    Yes
                  </label>
                </div>
                <div className="form-check d-inline-block hand ml20">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="systemstatus"
                    id="inactivesystem"
                    onChange={handlesystem}
                    value="0"
                    checked={systemcheck == 0}
                  />
                  <label className="form-check-label" for="inactivesystem">
                    No
                  </label>
                </div>
              </div>
              <div
                className="mb-2"
                style={{ display: `${systemcheck == 1 ? "block" : "none"}` }}
              >
                <label className="col-form-label">System Type</label>
                <select className="form-select">
                  <option>Select system type</option>
                  <option>Desktop</option>
                  <option>Laptop</option>
                </select>
              </div>
            </form>
            <div className="modalfooter">
              <button
                type="button"
                onClick={handleClose}
                className="btn_6 float-end ml10"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn_5 float-end"
                onClick={SaveItRequest}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal>
      ) : (
        ""
      )}

      <div className="page-header">
        <h1>
          {hr_permission_arr?.includes("26") && (
            <Link className="btn_5 mr10 float-end" to="/addemployee">
              Add Employee
            </Link>
          )}
          <>
            {((user_info.deptId == 25 && user_info.id == 1) ||
              (user_info.deptId == 1 &&
                (user_info.id == 3 || user_info.id == 6))) && (
              <div>
                <Link
                  className="btn_5 mr10 float-end"
                  onClick={downloadxlsxfile}
                >
                  Download Actual MHR
                </Link>
                <Link
                  className="btn_5 mr10 float-end"
                  onClick={() => setShowModalctc(true)}
                >
                  Bulk Upload Actual MHR
                </Link>
              </div>
            )}
            {showModalctc && (
              <>
                <div
                  className="modal-backdrop fade show"
                  onClick={() => setShowModalctc(false)}
                ></div>

                <div className="modal fade show" style={{ display: "block" }}>
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Bulk Upload Actual MHR</h5>
                        <button
                          className="btn-close"
                          onClick={() => setShowModalctc(false)}
                        ></button>
                      </div>

                      <div className="modal-body">
                        <div className="mb-3">
                          <label className="form-label">Upload File</label>
                          <input
                            type="file"
                            className="form-control"
                            accept=".csv"
                            ref={fileRef}
                            onChange={(e) => setFile(e.target.files[0])}
                          />
                        </div>
                      </div>
                      <div className="modal-footer">
                        <span style={{ color: "green" }}>
                          {ucword(bulkuploadmsg)}
                        </span>
                        <button
                          className="btn btn-secondary"
                          onClick={() => setShowModalctc(false)}
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleSubmit}
                          disabled={uploading}
                        >
                          {uploading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Uploading... Please wait
                            </>
                          ) : (
                            "Upload"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
          Employee
        </h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li className="current">
            <span>/</span> Employee
          </li>
        </ul>
      </div>
      <div className="row_bg">
        <div className="dash_white_box2 mb20 p20">
          <div className="dash_white_box_ttl">Search</div>
          <div className="row mb10">
            <div className="col-lg-3 col-md-6 pr07">
              <label className="form-label">Employee Name / Code</label>
              <input
                type="text"
                className="form-control"
                onChange={(e) => setSearchbytext(e.target.value)}
                value={searchbytext}
                autoComplete="none"
                placeholder="Search by name"
              />
            </div>

            <div className="col-lg-3 col-md-6 pl07 pr07">
              <label className="form-label">Company</label>
              <div className="form-input">
                {/* <select
                  onChange={HandleCompany}
                  value={compId}
                  className="form-select"
                >
                  <option value="">Select Company</option>
                  {comdata?.map((item, ind) => (
                    <option key={ind} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select> */}
                <Select
                  options={comdata}
                  value={comdata.find((opt) => opt.value === compId) || null}
                  onChange={(opt) => setCompId(opt?.value || "")}
                  placeholder="Select Company"
                  isSearchable
                  isClearable
                />
              </div>
            </div>

            <div className="col-lg-3 col-md-6 pl07 pr07">
              <label className="form-label">Division</label>
              <div className="form-input">
                <Select
                  options={dept}
                  value={dept.find((opt) => opt.value === deptid) || null}
                  onChange={(opt) => setDeptid(opt?.value || "")}
                  placeholder="Select Division"
                  isSearchable
                  isClearable
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-6 pl07 mb20">
              <label className="form-label"> Department </label>
              <div className="form-input">
                <Select
                  options={skillsList}
                  value={skillsList.find((opt) => opt.value === skill) || null}
                  placeholder="Select Department"
                  onChange={(opt) => {
                    setSelectedSkill(opt ? opt.value : "");
                    setSkill(opt?.value || "");
                  }}
                  isSearchable={true}
                  isClearable
                />
              </div>
            </div>

            <div className="col-lg-3 col-md-6 pl07 mb20">
              <label className="form-label"> Skill</label>
              <div className="form-input">
                <Select
                  options={skillrole}
                  value={skillrole.find((opt) => opt.value === role) || null}
                  onChange={(opt) => setRole(opt?.value || "")}
                  placeholder="Select Skill"
                  isSearchable
                  isClearable
                />
              </div>
            </div>

            <div className="col-lg-3 col-md-6 pr07">
              <label className="form-label"> Status</label>
              <div className="form-input">
                <select
                  value={activeType}
                  className="form-select"
                  onChange={(e) => {
                    setActiveType(e.target.value);
                  }}
                >
                  <option value="">Select Status </option>
                  <option value="1">Active</option>
                  <option value="2">Inactive</option>
                </select>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 pl07 pr07">
              <label className="d-block mb30 pt07"></label>
              <button onClick={Search_filter} className="btn_5 mr08">
                Search
              </button>
              <button onClick={Reset_filter} className="btn_6">
                Reset
              </button>
            </div>
          </div>
        </div>
        <div className="row mb30">
          <div className="col-md-12">
            <table className="table_style_1">
              <thead>
                <tr>
                  <th>Employee Code</th>
                  <th>Employee Name</th>
                  <th>Division</th>
                  <th>Department </th>
                  <th>Skill </th>
                  <th>Employee Type</th>
                  <th>Status</th>
                  <th style={{ width: "140px" }}>Action</th>
                </tr>
              </thead>
              {loadPage === true ? (
                <TableLoader colSpan={7} />
              ) : (
                <tbody>
                  {emplist?.map((item, ind) => {
                    return (
                      <tr key={ind}>
                        <td>
                          {" "}
                          <span
                            className={`emp-code-badge ${
                              empCode === item.user_code ? "active" : ""
                            }`}
                            onClick={(e) => {
                              handleEmployeeCode(item.user_code, item.id);
                            }}
                          >
                            {item.user_code ? item.user_code : ""}
                          </span>
                        </td>
                        <td>
                          <span className="avatar_icon">
                            {item.name
                              ? item.name
                                  .match(/(\b\S)?/g)
                                  .join("")
                                  .match(/(^\S|\S$)?/g)
                                  .join("")
                                  .toUpperCase()
                              : ""}
                          </span>
                          {item.name}
                        </td>
                        <td>{item.dept_name}</td>
                        <td>{item.sub_dept_name}</td>
                        <td>{item.skillName}</td>
                        <td>{item.user_type == 1 ? "Payroll" : "Contract"}</td>
                        <td>{item.status === 1 ? "Active" : "Inactive"}</td>
                        <td>
                          {/* {
                        hr_permission_arr?.includes('28') && (<button className="btn_5 mr03">View</button>)
                      } */}
                          {hr_permission_arr?.includes("27") && (
                            <Link
                              to={`/viewemployee?id=${+item.id}`}
                              className="btn_5 mr07"
                            >
                              View
                            </Link>
                          )}
                          {hr_permission_arr?.includes("27") && (
                            <Link
                              to={`/editemployee?id=${+item.id}`}
                              className="btn_7"
                            >
                              Edit
                            </Link>
                          )}
                          {/* {
                        item.official_email_status==0 && item.email_verify==1?<button className="btn_5 mr03" >Sent</button>:item.official_email_status==1 && item.email_verify==1?<button className="btn_5 mr03" >Created</button>:<button className="btn_5 mr03" onClick={() => itModal(item.id)}>Send</button>
                      } */}
                        </td>
                      </tr>
                    );
                  })}
                  {emplist.length < 1 && (
                    <tr className="error_mgs">
                      <td colSpan={7}>
                        <center>No Record Found</center>
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
              {emplist.length > 0 && (
                <tfoot>
                  <tr>
                    <td colSpan="8">
                      <span
                        onClick={(e) =>
                          pagination.current.setState({ selected: 10 - 1 })
                        }
                      ></span>
                      <ReactPaginate
                        ref={pagination}
                        pageCount={Math.ceil(totalitem / perPage)}
                        pageRangeDisplayed={4}
                        marginPagesDisplayed={1}
                        onPageChange={setPage}
                        containerClassName="pagination"
                        activeClassName="active"
                        pageLinkClassName="page-link"
                        breakLinkClassName="page-link"
                        nextLinkClassName="page-link"
                        previousLinkClassName="page-link"
                        pageClassName="page-item"
                        breakClassName="page-item"
                        nextClassName="page-item"
                        previousClassName="page-item"
                        previousLabel={<>&laquo;</>}
                        nextLabel={<>&raquo;</>}
                      />
                    </td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default EmployeeListCom;
